import { useCallback, useMemo } from "react";
import { mutate } from "swr";

import {
  applicationEndPoints,
  organizationApplicationEndpoints
} from "@api/Endpoints";
import { putData } from "@hooks/usePutData";

export function useAssociateApplication() {
  const associate = useCallback(
    async (applicationId: string, organizationId: string) => {
      const url = applicationEndPoints.associate(applicationId, organizationId);
      const result = await putData(url);
      const getUrl = organizationApplicationEndpoints.get(organizationId);
      await mutate(getUrl);
      return result;
    },
    []
  );

  return useMemo(() => ({ associate }), [associate]);
}
